import { List, useRecordContext } from "react-admin";
import { DrivingSchool } from "../../providers/drivingSchoolsProvider";
import { LoadingIndicator } from "../../misc/LoadingIndicator";
import { PageTitle } from "../../misc/PageTitle";
import { Button, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router";
import { Row } from "../../misc/Row";
import { EmptyState } from "../../misc/EmptyState";
import { Column } from "../../misc/Column";
import { ResponsiveListSurface } from "../../misc/ResponsiveListSurface";
import { TimetablesDataGrid } from "./TimetablesDataGrid";

export function DrivingSchoolTimetables() {
  const drivingSchool = useRecordContext<DrivingSchool>();
  const navigate = useNavigate();

  if (!drivingSchool) {
    return (
      <>
        <PageTitle>Stundenpläne</PageTitle>
        <LoadingIndicator />
      </>
    );
  }

  const empty = <EmptyState />;

  return (
    <Column>
      <div style={{ position: "relative" }}>
        <Row
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: "30px", minHeight: "32px", columnGap: 2, flexWrap: { xs: "wrap", sm: "nowrap" }, rowGap: 1 }}
        >
          <PageTitle documentTitle="Stundenpläne">
            <h2 style={{ margin: 0, lineHeight: 0.83 }}>Stundenpläne</h2>
          </PageTitle>
          <IconButton
            aria-label="Stundenplan hinzufügen"
            color="primary"
            onClick={() => navigate("/timetables/create")}
            size="small"
            sx={{ display: { xs: "inline-flex", sm: "none" } }}
          >
            <AddIcon />
          </IconButton>
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={() => navigate("/timetables/create")}
            size="small"
            sx={{ display: { xs: "none", sm: "inline-flex" } }}
          >
            Hinzufügen
          </Button>
        </Row>
        <ResponsiveListSurface variant="compactStandalone" data-testid="DrivingSchoolTimetables">
          <List
            resource="timetables"
            title=" "
            actions={false}
            filter={{ drivingSchoolId: drivingSchool.id }}
            sort={/* initial sort order: */ { field: "name", order: "ASC" }}
            exporter={false}
            hasCreate={false}
            empty={empty}
          >
            <TimetablesDataGrid empty={empty} />
          </List>
        </ResponsiveListSurface>
      </div>
    </Column>
  );
}
